
import whatsapp from '../../assets/projects_images/whatsapp.png'
import detail from '../../assets/projects_images/detail.png'

import pima from '../../assets/projects_images/pima.jpg'
import sentiment from '../../assets/projects_images/sentiment.jpg'

const data_projects = [
    {
        name: 'Diabetes detector',
        image: pima,

        github_url: 'https://github.com/chrpkorir/Pima-Diabetes',
        category: ['machine']
    },

    {
        name: 'Sentiment Analysis',
        image: sentiment,
        github_url: 'https://github.com/chrpkorir/Sentiment-Analysis',
        category: ['machine','python']
    },

    {
        name: 'WhatsApp Chat bot',
        image: whatsapp,
        github_url: 'https://github.com/chrpkorir/whatsapp-chatbot',
        category: ['python']
    },

    {
        name: 'Sabi Edchange',
        image: detail,
        github_url: 'https://github.com/chrpkorir/Sabi',
        category: ['django', 'react']
    }



   /* {
        name: 'Dev Portfolio',
        image: portfolio,
        deployed_url: 'http://suprateem.herokuapp.com/',
        category: ['vanilla']
    },*/






]

export default data_projects;